import { ViewStackViewComponent } from 'src/app/components/view-stack/view-stack-view/view-stack-view.component';
import { Component, OnInit, ViewChild, Input, ElementRef, Output, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-view-stack-view-unencapsulated',
	templateUrl: './view-stack-view-unencapsulated.component.html',
	styleUrls: ['./view-stack-view-unencapsulated.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class ViewStackViewUnencapsulatedComponent extends ViewStackViewComponent {


}
